module.exports = __webpack_public_path__ + "static/media/product-summary-3.91002190.jpg";